import type { RouteAlert } from '../hooks/useSimulationWorker';

interface AlertsPanelProps {
  alerts: readonly RouteAlert[];
}

export function AlertsPanel({ alerts }: AlertsPanelProps) {
  return (
    <div className="card-body">
      <div className="card-head">
        <h2>Route Alerts</h2>
        <span className="muted">{alerts.length === 0 ? 'All clear' : `${alerts.length} recent`}</span>
      </div>
      <ul className="alerts">
        {alerts.map((alert) => (
          <li key={alert.id} className={`alert alert-${alert.severity}`}>
            <span className="alert-dot" aria-hidden="true" />
            <div>
              <div className="alert-title">{alert.title}</div>
              <div className="alert-detail">{alert.detail}</div>
            </div>
          </li>
        ))}
        {alerts.length === 0 && <li className="muted empty">Alerts appear after the first daily close.</li>}
      </ul>
    </div>
  );
}
